import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import showToast from "../../../../../services/toast";
import { AlertLoadingHeader } from "../../../../../components/alertLoadingComponent/alertLoading";
export var PoliciesHeaderView = function (props) {
    return (_jsx(AlertLoadingHeader, { loading: props.loading, seeToast: props.seeToast, showToast: showToast, setSeeToast: props.setSeeToast, titleLoading: props.isLoadin ? "Descargando archivo" : "Cargando..." }));
};
